import { render, staticRenderFns } from "./FIFAWorldCupFull_FIFAWC.vue?vue&type=template&id=1cba77c0"
import script from "./FIFAWorldCupFull_FIFAWC.vue?vue&type=script&lang=js"
export * from "./FIFAWorldCupFull_FIFAWC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports